module.exports = __webpack_public_path__ + "static/img/COC2021-26.8b20081.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-26.jpg
// module id = e05K
// module chunks = 0